import React, { useState } from 'react';
import styled from 'styled-components';

import { Stack } from '@mui/material';
import { AITool } from '../../tool.types';
import { Label } from '@common/Label';
import { ToolsAutocomplete } from '@common/Autocomplete/ToolAutocomplete';
import { Button } from '@common/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.5rem;
`;

interface Props {
  onToolSelected: (selectedTool: AITool) => void;
}

export const AssistantToolCopy: React.FC<Props> = ({ onToolSelected }) => {
  const [selectedTool, setSelectedTool] = useState<AITool | null>(null);

  const handleCopyTool = () => {
    if (selectedTool) {
      onToolSelected(selectedTool);
    }
  };

  return (
    <Container>
      <Label
        title='Copy Existing Tool'
        tooltip='Select an existing tool to copy its configuration. You can modify the configuration after copying.'
      />
      <Stack spacing={1.5}>
        <ToolsAutocomplete
          value={selectedTool?.id || null}
          onChange={(_, value) => setSelectedTool(value)}
          placeholder='Select Tool'
        />
        <Button customColor='black' onClick={handleCopyTool} disabled={!selectedTool} fullWidth>
          Copy Tool
        </Button>
      </Stack>
    </Container>
  );
};
